import { useEffect, useRef, useState } from 'react';
import { supabase } from '../supabaseClient';
import { openLanding, PLUSZ_PATH } from '../lib/openLanding';

/* ══════════════════════════════════════════════════════════════════════════
   GOMBOS PRÓBA a kurzusoldalon (Plusz 1. kör, B. rész)
   ─────────────────────────────────────────────────────────────────────────
   Sáv: „A tanfolyam mellé: indítsd el a 14 napos PRO-próbát.” Csak annak
   látszik, akinek még nem volt próbája, és nem PRO (trial_state 'nincs').
   A próbát a start_trial() RPC indítja; a szövegek ugyanazok, mint a
   terminálban és a landing dashboardján. Mérés: trial_cta_view,
   trial_start_click, trial_start_blocked (az events táblába, saját sorként);
   a trial_started-et az RPC írja.
   ══════════════════════════════════════════════════════════════════════════ */

const CYAN = '#00D2C8';
const TERMINAL = 'https://terminal.web3kurzus.hu';
const LIST = [
  'Szkenner a top 100 coinra, RSI-áttekintés több idősíkon, Funding, Stratégiák, ETF',
  '22 coin derivatíva-adatai és a Put/Call',
  'Hőtérkép a top 200 coinra',
  '50 aktív riasztás, Telegramon is (ár, tervszint, RSI, funding, OI)',
  'Napi Telegram-összesítő',
];
const REASON = {
  already_used: 'Ehhez a fiókhoz vagy e-mail-címhez már tartozott próba. A terminál teljes tudását Plusszal vagy PRO-val éred el.',
  email_unconfirmed: 'Előbb erősítsd meg az e-mail-címed.',
  disposable: 'Állandó e-mail-címmel indítható.',
};
const GENERIC = 'A próbát most nem sikerült elindítani. Próbáld újra pár perc múlva.';

const track = (session, name, props) => {
  supabase.from('events').insert({ user_id: session?.user?.id ?? null, event_name: name, properties: props })
    .then(() => undefined, () => undefined);
};

const btn = (primary) => ({
  border: primary ? 'none' : '1px solid rgba(255,255,255,0.15)', borderRadius: 10, padding: '11px 16px',
  fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
  background: primary ? CYAN : 'rgba(255,255,255,0.04)', color: primary ? '#0a0f1e' : 'rgba(255,255,255,0.85)',
});

export default function TrialStrip({ session, access, onStarted }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [reason, setReason] = useState(null);
  const [resent, setResent] = useState('');
  const [started, setStarted] = useState(false);
  const show = !!access && access.trial_state === 'nincs' && access.tier !== 'pro';

  useEffect(() => { if (show) track(session, 'trial_cta_view', { hely: 'egyetem' }); }, [show]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!show && !started) return null;

  const open = () => { track(session, 'trial_start_click', { hely: 'egyetem' }); setReason(null); setResent(''); ref.current?.showModal(); };
  const close = () => ref.current?.close();
  const start = async () => {
    setBusy(true); setReason(null);
    const { data, error } = await supabase.rpc('start_trial');
    setBusy(false);
    if (!error && data?.ok) { close(); setStarted(true); onStarted?.(); return; }
    const r = data?.reason || 'error';
    setReason(r);
    track(session, 'trial_start_blocked', { ok: r, hely: 'egyetem' });
  };
  const resend = async () => {
    const email = session?.user?.email;
    if (!email) return;
    const { error } = await supabase.auth.resend({ type: 'signup', email });
    setResent(error ? 'Nem sikerült elküldeni. Próbáld újra pár perc múlva.' : 'Elküldtük a megerősítő levelet.');
  };

  return (
    <>
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap',
        background: 'rgba(0,210,200,0.06)', border: '1px solid rgba(0,210,200,0.22)',
        borderRadius: 12, padding: '12px 16px', margin: '0 0 24px',
      }}>
        {started ? (
          <>
            <span style={{ color: 'rgba(255,255,255,0.85)', fontSize: 14, lineHeight: 1.5 }}>
              A próba elindult: 14 napig a terminál minden PRO-funkciója a tiéd.
            </span>
            <a href={TERMINAL} style={{ ...btn(true), textDecoration: 'none' }}>Megnyitom a terminált →</a>
          </>
        ) : (
          <>
            <span style={{ color: 'rgba(255,255,255,0.85)', fontSize: 14, lineHeight: 1.5 }}>
              A tanfolyam mellé: 14 nap PRO-terminál ingyen, élő adattal és riasztásokkal.
            </span>
            <button type="button" onClick={open} style={btn(true)}>Indítsd el a 14 napos PRO-próbát</button>
          </>
        )}
      </div>

      <dialog ref={ref} aria-labelledby="eg-trial-cim" onClick={(e) => { if (e.target === ref.current) close(); }}
        style={{ margin: 'auto', inset: 0, width: 'min(520px, calc(100vw - 32px))', padding: 0, border: '1px solid rgba(255,255,255,0.1)', borderRadius: 16, background: '#111827', color: '#fff' }}>
        <div style={{ padding: 24, display: 'grid', gap: 14, fontFamily: "'Inter', system-ui, sans-serif" }}>
          <h2 id="eg-trial-cim" style={{ margin: 0, fontSize: 20 }}>14 nap PRO-terminál, ingyen</h2>
          <ul style={{ margin: 0, paddingLeft: 20, display: 'grid', gap: 6, fontSize: 14, lineHeight: 1.5, color: 'rgba(255,255,255,0.85)' }}>
            {LIST.map(t => <li key={t}>{t}</li>)}
          </ul>
          <p style={{ margin: 0, fontSize: 13, lineHeight: 1.6, color: 'rgba(255,255,255,0.6)' }}>
            Bankkártya nem kell, és a végén nem indul előfizetés. Egyszer indítható, és ha beállítod az első riasztásod, még 7 nappal hosszabb lesz. A próba a terminálra szól: a tanfolyamot és a segédleteket a szinted szerint látod.
          </p>
          {reason && (
            <div role="alert" style={{ padding: '12px 14px', borderRadius: 10, border: '1px solid rgba(248,113,113,0.35)', background: 'rgba(248,113,113,0.08)', fontSize: 14, lineHeight: 1.5, display: 'grid', gap: 8, justifyItems: 'start' }}>
              <span>{REASON[reason] || GENERIC}</span>
              {reason === 'email_unconfirmed' && (
                <>
                  <button type="button" onClick={resend} style={btn(false)}>Megerősítő levél újraküldése</button>
                  {resent && <span role="status">{resent}</span>}
                </>
              )}
            </div>
          )}
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            {!reason && <button type="button" onClick={start} disabled={busy} style={btn(true)}>{busy ? 'Indítás…' : 'Indítom a próbát'}</button>}
            {reason === 'already_used' && <button type="button" style={btn(true)} onClick={() => { track(session, 'plusz_cta_click', { hely: 'egyetem_already_used' }); openLanding(PLUSZ_PATH); }}>Plusz megnézése</button>}
            <button type="button" onClick={close} style={btn(false)}>{reason ? 'Bezárás' : 'Most nem'}</button>
          </div>
        </div>
      </dialog>
    </>
  );
}
